interface FinalCTASectionProps {
  onCtaClick: () => void;
}

export default function FinalCTASection({ onCtaClick }: FinalCTASectionProps) {
  return (
    <section className="relative py-32 md:py-48 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/7db3fdd46496288ddecb075469774c75.jpg')`,
        }}
      />
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(155deg, rgba(5,13,9,0.94) 0%, rgba(8,18,13,0.86) 50%, rgba(5,13,9,0.95) 100%)' }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <div
          className="inline-flex items-center gap-2 border rounded-full px-4 py-1.5 mb-10"
          style={{ borderColor: 'rgba(93,196,142,0.18)' }}
        >
          <div
            className="w-1.5 h-1.5 rounded-full flex-shrink-0 animate-pulse"
            style={{ backgroundColor: '#5DC48E' }}
          ></div>
          <span
            className="text-xs tracking-widest uppercase"
            style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.5)' }}
          >
            Pinneberg · Jetzt Termin sichern
          </span>
        </div>

        <h2
          className="text-3xl md:text-5xl lg:text-[58px] font-bold text-white leading-[1.08] tracking-tight"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Dein erster Schritt<br />
          kostet dich{' '}
          <em className="not-italic" style={{ color: '#5DC48E' }}>gar nichts.</em>
        </h2>

        <p
          className="text-base md:text-lg mt-7 max-w-xl mx-auto leading-relaxed"
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.48)' }}
        >
          Kein Abo. Keine Unterschrift. Keine Überredung.
          Du kommst, du trainierst, du entscheidest danach – vollständig frei, vollständig ohne Druck.
          Das ist unser Versprechen an jeden Menschen, der das erste Mal zu uns kommt.
        </p>

        <div className="mt-4 mb-10">
          <p
            className="text-base md:text-lg leading-relaxed"
            style={{ fontFamily: 'Cormorant Garamond, serif', color: 'rgba(255,255,255,0.35)', fontStyle: 'italic' }}
          >
            „Nicht weil wir müssen. Weil wir wissen, dass ein Probetraining mehr überzeugt
            als jedes Versprechen auf einer Website."
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
          <button
            onClick={onCtaClick}
            className="text-white font-semibold text-sm px-10 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            style={{ backgroundColor: '#1A5C3D', fontFamily: 'Inter, sans-serif' }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1E6B47')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1A5C3D')}
          >
            Kostenloses Probetraining sichern
          </button>
          <button
            onClick={() => { const el = document.getElementById('faq'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
            className="border text-sm px-9 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            style={{
              borderColor: 'rgba(255,255,255,0.18)',
              color: 'rgba(255,255,255,0.55)',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 300,
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.38)'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)'; e.currentTarget.style.color = 'rgba(255,255,255,0.55)'; }}
          >
            Noch Fragen? →
          </button>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          {[
            { icon: 'ri-shield-check-line', text: 'Kein Mitgliedschaftszwang' },
            { icon: 'ri-map-pin-line', text: 'Direkt in Pinneberg, mit Parkplatz' },
            { icon: 'ri-timer-line', text: 'Rückmeldung innerhalb 24 Stunden' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-sm`} style={{ color: 'rgba(93,196,142,0.5)' }}></i>
              </div>
              <span
                className="text-xs"
                style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.3)' }}
              >
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
